// REST-Clients fuer die Export-Routen aus backend/src/export/routes.ts.
//
// Polish P2: Backend liefert pro Export-Eintrag signierte Download-URLs mit kurzem TTL.
// Frontend setzt diese URL direkt in `<a href download>` — kein Bearer + Blob-Workaround mehr.

import { api } from "../lib/api.js";

export type ExportFile = "board.pdf";
export type ExportFormat = "pdf";

export interface SignedDownload {
  file: ExportFile;
  url: string;
  expiresAt: number; // unix seconds
}

export interface ExportSummaryDto {
  id: string;
  boardId: string;
  userId: string;
  format: ExportFormat;
  status: "running" | "done" | "failed";
  artifactDir: string | null;
  error: string | null;
  triggeredAt: string;
  completedAt: string | null;
  downloads: SignedDownload[];
}

export const exportApi = {
  list: (boardId: string) =>
    api
      .get<{ exports: ExportSummaryDto[] }>(`/api/boards/${boardId}/exports`)
      .then((r) => r.exports),
  trigger: (boardId: string) =>
    api
      .post<{ export: ExportSummaryDto }>(`/api/boards/${boardId}/export`, {})
      .then((r) => r.export),
};
